interface V3IconCheckProps extends React.SVGProps<SVGSVGElement> {
}

export const V3IconCheck = ({ ...rest }: V3IconCheckProps) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E77FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...rest}>
    <polyline points="20 6 9 17 4 12" />
</svg>

